export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Favorite-White-a698eb6dca31bce7fcc35e7fe4d09727.svg";